import * as validators from '_utils/validationChecks';
import { SitecoreFieldValidator } from '_utils/validationChecks/definitions'

export const contactDetailsFormValidators: SitecoreFieldValidator[] = [
  {
    field: 'rendering.fields.data.datasource.myAccountLink',
    errorMessage: 'A valid link to the My Account page must be provided',
    required: true,
    validators: [validators.isValidLink]
  },
  {
    field: 'rendering.fields.data.datasource.editEmailLink',
    errorMessage: 'A valid link to help customers edit their email must be provided',
    required: true,
    validators: [validators.isValidLink]
  },
  {
    field: 'rendering.fields.data.datasource.editMobileLink',
    errorMessage: 'A valid link to help customers edit their mobile phone must be provided',
    required: true,
    validators: [validators.isValidLink]
  },
  {
    field: 'rendering.fields.data.datasource.nameChangeLink',
    errorMessage: 'A valid link to the name change form must be provided',
    required: false,
    validators: [validators.isValidLink]
  }
];
